export default __webpack_public_path__ + "static/media/following.cdcf62bf.svg";